import { BLACK_COLOR, WHITE_COLOR } from './variables';

type Writer = (context: CanvasRenderingContext2D, text: string, x: number, y: number) => void;

export const tategaki: Writer = (context, text, x, y) => {
    const textList = text.split('\n');
    const lineHeight = context.measureText('あ').width;
    context.fillStyle = WHITE_COLOR;
    textList.forEach((elm, i) => {
        Array.prototype.forEach.call(elm, (ch, j) => {
            context.fillText(ch, x - lineHeight * i, y + lineHeight * j);
        });
    });
};

export const tategakiStroke: Writer = (context, text, x, y) => {
    const textList = text.split('\n');
    const lineHeight = context.measureText('あ').width;
    context.lineWidth = 3;
    textList.forEach((elm, i) => {
        Array.prototype.forEach.call(elm, (ch, j) => {
            context.strokeStyle = WHITE_COLOR;
            context.strokeText(ch, x - lineHeight * i, y + lineHeight * j);
            context.fillStyle = BLACK_COLOR;
            context.fillText(ch, x - lineHeight * i, y + lineHeight * j);
        });
    });
};
